// extracted by mini-css-extract-plugin
export var list = "social-zone-module--list--3093d";